(function(w, d) {
  const allProductPaginations = d.querySelectorAll('[data-pagination-bullet]');
  const amountOfPaginations = allProductPaginations.length;
  const productImagesContainer = d.querySelector('[data-product-images-container]')
  const productImagesWrapper = d.querySelector('[data-product-images-wrapper]')
  const productImageHeight = d.querySelector('[data-product-image]').getBoundingClientRect().height
  const productImages = [...d.querySelectorAll('[data-product-image]')]
  const observerThreshold = w.innerHeight < productImageHeight ? (w.innerHeight / productImageHeight - 0.05) : 0.9
  
  const toggleProductPaginationActive = (targetIndex) => {
    allProductPaginations.forEach(bullet => {
      bullet.classList[bullet.dataset.index == targetIndex ? 'add' : 'remove']('active')
    })
  }
  
  const scrollProductImages = (targetIndex) => {
    const wrapperTop = productImagesWrapper.getBoundingClientRect().top
    const target = productImages.find(img => img.dataset.productImage == targetIndex)
    const targetTop = target.getBoundingClientRect().top;
    productImagesContainer.scrollTo({
      top: targetTop - wrapperTop,
      behavior: 'smooth'
    })

    w.scrollTo({
      top: parseInt(targetIndex, 10) === amountOfPaginations ? w.innerHeight * 0.3 : 0,
      behavior: 'smooth'
    })
  }
  
  const productImagesObserverOption = {
    threshold: observerThreshold
  }
  const productImagesObserver = new IntersectionObserver(((entries, observer) => {
    if (entries[0].isIntersecting) {
      toggleProductPaginationActive(parseInt(entries[0].target.dataset.productImage, 10))
    }
  }), productImagesObserverOption);


  allProductPaginations.forEach(bullet => bullet.addEventListener('click', () => scrollProductImages(bullet.dataset.index)))
  productImages.forEach(img => productImagesObserver.observe(img))
}(window, document));
